import Gesture from './gesture';
import GestureAbstract from './abstract';
import GestureMove from './move';
import GestureResize from './resize';
import GestureRotate from './rotate';
import GestureScroll from './scroll';
import GestureDraw from './draw';

export default function initGestures () {
  INKIVE.Gesture = Gesture;
  INKIVE.GestureAbstract = GestureAbstract;
  INKIVE.GestureMove = GestureMove;
  INKIVE.GestureResize = GestureResize;
  INKIVE.GestureRotate = GestureRotate;
  INKIVE.GestureScroll = GestureScroll;
  INKIVE.GestureDraw = GestureDraw;
}
